<template>
  <div>
    <v-tabs
    v-model="tab"
    flat
    background-color="primary"
    dark
    height="40"
    grow grow @change="refreshData()" >
    <v-tab v-for="(tabItem, n) in tabItems" :key="n" :href="`#tab-${n}`">
      {{ tabItem + ' (' + totalStats[n] + ')' }}
    </v-tab>
  </v-tabs>
  <v-container fluid class="py-0">
    <v-layout row wrap>
      <v-flex xs12 sm10 mx-auto class="ma-1 pa-0">
        <v-tabs-items v-if="lAction === 'view'" v-model="tab" @change="refreshData()">
          <v-tab-item v-for="(tabItem, n) in tabItems" :key="n" :value="`tab-${n}`">
            <v-layout v-if="tabItem === 'pend. app'" class="pa-0" row wrap>
              <v-flex xs11 mx-auto>
                <v-card flat>
                  <v-card-title>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field
                        class="pa-0 mt-1"
                        append-icon="mdi-account-search-outline"
                        :placeholder="$vuetify.breakpoint.smAndUp?'Search community, date, etc...':'Search'"
                        single-line
                        hide-details
                        v-model="search1"
                        outlined
                        clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 class="pt-3">
                        <v-download-as
                        :headers="fmUpdate"
                        :items="downloadPendApp"
                        title="FM Daily Update - Pending For Approval"
                        ></v-download-as>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-card-text class="pa-1">
                    <v-data-table
                    :headers="$vuetify.breakpoint.smAndUp?fmUpdate:fmUpdateSm"
                    :items="lFmUpdate[0]"
                    :options.sync="pagination"
                    sort-by="updated_on"
                    sort-desc
                    :search="search1"
                    class="elevation-2"
                    :mobile-breakpoint="0">
                    <template slot="item" slot-scope="props">
                      <tr @click="loadDailyUpdateBasedOnComm(props.item)">
                        <td v-if="$vuetify.breakpoint.smAndUp">{{ handy.formatDate(props.item.c_date) }}</td>
                        <td>{{ props.item.comm_name }}</td>
                        <td>{{ props.item.updated_by_staff_name }}</td>
                        <td>{{ props.item.updated_on ? handy.formatDisplayDateTime(props.item.updated_on) : '' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout v-else row wrap>
            <v-flex xs11 mx-auto>
              <v-card flat>
                <v-card-title class="pt-0 pl-1">
                  <v-flex xs12 class="pa-0">
                    <v-layout>
                      <v-flex xs6>
                        <v-text-field
                        class="pa-0 mt-1"
                        append-icon="mdi-account-search-outline"
                        :placeholder="$vuetify.breakpoint.smAndUp?'Search community, date, etc...':'Search'"
                        single-line
                        hide-details
                        v-model="search2"
                        outlined
                        clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 class="pt-3">
                        <v-download-as
                        :headers="fmSub"
                        :items="downloadPendSub"
                        title="FM Daily Update - Pending For Submiision"
                        ></v-download-as>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="pt-1">
                    <span v-for="(chip, index) in reportChip" :key="index" class="pr-2">
                      <v-chip small @click="loadPendSubBasedOnPeriod(chip)" :class="enableChip === chip ? 'info white--text' : ''">
                        {{chip}}
                      </v-chip>
                    </span>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="enableChip === 'Period'">
                    <v-layout row wrap class="ml-2">
                      <v-flex xs5 class="pr-1">
                        <v-dialog ref="dlgFromDate"
                        persistent v-model="dlgFromDate"
                        max-width="290px"
                        :return-value.sync="periodFrom"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="From"
                          v-model="periodFrom" append-icon="mdi-calendar-today"
                          readonly clearable hide-details
                          v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="periodFrom" scrollable
                        first-day-of-week="1"
                        >
                        <v-spacer></v-spacer>
                        <v-btn text @click="dlgFromDate = false">Cancel</v-btn>
                        <v-btn text color="accent" @click="$refs.dlgFromDate[0].save(periodFrom)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs5 class="pl-1">
                    <v-dialog ref="dlgToDate"
                    persistent v-model="dlgToDate"
                    max-width="290px"
                    :return-value.sync="periodTo"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      label="To"
                      v-model="periodTo" append-icon="mdi-calendar-today"
                      readonly clearable hide-details
                      v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="periodTo" scrollable
                    first-day-of-week="1"
                    >
                    <v-spacer></v-spacer>
                    <v-btn text @click="dlgToDate = false">Cancel</v-btn>
                    <v-btn text color="accent" @click="$refs.dlgToDate[0].save(periodTo)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs2 class="text-center pt-3">
                <v-btn small fab class="accent" @click.native="loadPendSubBasedOnPeriod('Period')">Go</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
          :headers="$vuetify.breakpoint.smAndUp?fmSub:fmUpdateSm"
          :items="lFmUpdate[1]"
          :options.sync="pagination"
          class="elevation-1"
          :search="search2"
          :mobile-breakpoint="0">
          <template slot="item" slot-scope="props">
            <tr @click="loadDailyUpdateBasedOnComm(props.item)">
              <td v-if="$vuetify.breakpoint.smAndUp">{{ handy.formatDate(props.item.c_date) }}</td>
              <td>{{ props.item.comm_name }}</td>
              <td>{{ props.item.updated_by }}</td>
              <td>{{ props.item.updated_on ? handy.formatDisplayDateTime(props.item.updated_on) : '' }}</td>
              <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.staff_name ? 'Draft' : 'NA' }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</v-tab-item>

<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn  v-on="on"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:285px;')"
    dark fab fixed
    color="accent"
    @click.native="prepareLookup">
    <v-icon>mdi-eye</v-icon>
  </v-btn>
</template>
<span>Checklist Lookup</span>
</v-tooltip>

</v-tabs-items>
</v-flex>
</v-layout>

<!-- Fixed menu for approval, previous day, next day, etc of daily update -->
<v-menu top offset-y v-if="lAction === 'update'">
  <template v-slot:activator="{ on }">
    <v-btn dark fab fixed :style="'position:fixed; ' + ($vuetify.breakpoint.smAndup?'bottom:65px; right:15px;':'bottom:15px; right:15px;')"
    color="accent" v-on="on">
    <v-icon>mdi-dots-vertical</v-icon>
  </v-btn>
</template>

<v-list class="pa-0">
  <v-list-item v-if="lDailyUpdate && lDailyUpdate.is_sub_app === 0 && lDailyUpdate.is_app === 0" class="pl-0" @click="submitApproval">
    <v-list-item-avatar><v-icon>mdi-check</v-icon></v-list-item-avatar>
    <v-list-item-title>Submit for Approval</v-list-item-title>
  </v-list-item>
  <v-list-item :disabled="!(lDailyUpdate && lDailyUpdate.is_sub_app === 1 && lDailyUpdate.is_app === 0)" class="pl-0" @click="approveUpdate">
    <v-list-item-avatar><v-icon>mdi-check</v-icon></v-list-item-avatar>
    <v-list-item-title>Approve</v-list-item-title>
  </v-list-item>
  <v-divider></v-divider>
  <v-list-item class="pl-0" @click="prevDay">
    <v-list-item-avatar><v-icon>mdi-chevron-left</v-icon></v-list-item-avatar>
    <v-list-item-title>Previous Day</v-list-item-title>
  </v-list-item>
  <v-list-item class="pl-0" @click="nextDay">
    <v-list-item-avatar><v-icon>mdi-chevron-right</v-icon></v-list-item-avatar>
    <v-list-item-title>Next Day</v-list-item-title>
  </v-list-item>
</v-list>
</v-menu>

<v-btn :style="'position:fixed; top:95px; right:10px;'" dark fab small fixed color="accent"
v-if="lAction === 'update'" @click.native="showTimeline = true">
<v-icon>mdi-chart-line-variant</v-icon>
</v-btn>

<!-- Show the particular site daily update for approval or any change to made -->
<v-container v-if="lAction === 'update'" class="pa-0" grid-list-md fluid full-height>
  <v-flex xs12 sm11 mx-auto>
    <v-flex xs12>
      <v-layout row wrap class="title mb-2">
        <v-flex xs12 sm6>
          <v-btn small icon class="black--text" @click="goBackToView()"><v-icon>mdi-arrow-left</v-icon></v-btn>
          <span class="px-2 primary--text">{{lFmDailyUpdate.comm_name}}</span>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="px-2 text-left text-right">CheckList Date: <span class="primary--text">{{handy.formatDate(lFmDailyUpdate.c_date)}}</span></div>
          <div class="text-right mt-2 mr-2">
            <v-btn small class="ma-0" @click="showUploadImage = true"><v-icon class="pr-2">mdi-camera-burst</v-icon>{{ 'Photos (' + lDailyUpdateAttach.fileUrls.length + ')'}}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-card flat class="ma-2" v-if="!lDailyUpdate.c_date">
      <v-card-text class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="text-center">
              <v-alert tile color="info white--text">
                No data is available for choosen date. You may start entering it.
              </v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <!-- current status -->
    <v-card flat class="ma-2">
      <v-card-text class="pa-0">
        <v-layout row wrap>
          <v-flex class="text-center" xs12 v-if="lDailyUpdate && lDailyUpdate.is_sub_app === 0 && lDailyUpdate.is_app === 0">
            <v-alert tile color="yellow" class="black--text body-2">
              {{ 'Draft, not submitted for approval yet. (Updated by: ' + (lDailyUpdate.updated_by_name || ' Vendor FM') + (lDailyUpdate.updated_on ? ' on ' + handy.formatDisplayDateTime(lDailyUpdate.updated_on) : '') + ')'}}
            </v-alert>
          </v-flex>
          <v-flex xs12 v-if="lDailyUpdate && lDailyUpdate.is_sub_app && lDailyUpdate.is_app === 0">
            <div class="text-center">
              <v-alert tile color="orange" class="white--text body-2">
                {{ 'Pending for Approval.'}}<br /><span class="caption">{{'Updated by: ' + (lDailyUpdate.updated_by_name || ' Vendor FM ') + (lDailyUpdate.updated_on ? ' on ' + handy.formatDisplayDateTime(lDailyUpdate.updated_on) : '') }}</span>
              </v-alert>
            </div>
          </v-flex>
          <v-flex xs12 v-if="lDailyUpdate && lDailyUpdate.is_app">
            <div class="text-center">
              <v-alert tile color="success" class="white--text body-2">
                {{ 'Approved.' }} <br /><span class="caption">{{'By: ' + (lDailyUpdate.app_by_name || ' Vendor manager ') + (lDailyUpdate.app_on ? ' on ' + handy.formatDisplayDateTime(lDailyUpdate.app_on) : '') }} </span>
              </v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <!-- Attendance -->
    <v-card class="ma-2">
      <v-card-title class="pt-0 pb-0 pl-2 pr-2 grey lighten-4">
        <div class="title primary--text">Attendance</div>
        <v-spacer></v-spacer>
        <router-link :to="{ path: '/attendance/' }" style="text-decoration: none; color: black;">
          <v-btn text class="pt-0 pb-0">go to Attendance</v-btn>
        </router-link>
      </v-card-title>
      <v-card-text class="pa-0 pr-1 pt-1">
        <v-layout row wrap>
          <v-flex xs4 sm2 class="mt-3 pr-0 pl-1">
            <v-card flat>
              <v-card-text class="pr-0">
                <div class="display-1 text-lg-center black--text">{{ lSummary[0].attAve >= 0 ? (lSummary[0].attAve + '%') : '0 %' }}</div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs8 sm10 class="pa-0 ma-0">
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp?attendance:attendanceSm"
            :items="lSummary"
            :mobile-breakpoint="0"
            hide-default-footer>
            <template slot="item" slot-scope="props">
              <tr @click="showAttendanceSummary(lDate)" :class="lSummary.length > 1 && props.index === 0 ? 'blue lighten-4' : ''">
                <td>{{ props.item.tot_present }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_wo }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_holiday }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_ot }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_leave }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_absent }}</td>
                <td class="red--text lighten-3 pa-2">{{ props.item.tot_pend }}</td>
                <td class="black--text lighten-3">{{ props.item.tot_staff }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
  <v-flex xs12 class="pa-2">
    <v-flex xs12 class="pt-2">
      <v-text-field
      v-model="lDailyUpdate.remark_attendance"
      label="Attendance Remark If Any"
      maxlength="150"
      hide-details
      @change="postObserv()"
      outlined
      ></v-text-field>
    </v-flex>
  </v-flex>

  <!-- Water Quality -->
  <v-card class="ma-2">
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title primary--text">Water Quality</div>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp ? watQual : watQualSm"
      :items="dailyQualList"
      :mobile-breakpoint="0"
      hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr @click="prepareEditWaterQual(props.item)">
          <td>{{ props.item.water_type ? props.item.water_type : '-' }}</td>
          <td>{{ props.item.param_name ? props.item.param_name : '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ (props.item.std_val_min ? props.item.std_val_min:0) + ' to ' + props.item.std_val_max }}</td>
          <td :class="(props.item.val < props.item.std_val_min || props.item.val > props.item.std_val_max) && props.item.val !== null ? 'error white--text' : 'black--text'">{{ props.item.val ? props.item.val : '-' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>

<!-- Water Management -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title primary--text">Water Management</div>
  </v-card-title>
  <v-card-text class="pa-2">
    <v-layout row wrap>
      <!-- water sources -->
      <v-flex xs12>
        <v-card>
          <v-card-text class="pt-2 pb-3">
            <v-layout row wrap>
              <v-flex xs12>
                <span class="px-2 primary--text">Water Sources</span>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                :headers="watType"
                :items="domWatList"
                :mobile-breakpoint="0"
                hide-default-footer>
                <template slot="item" slot-scope="props">
                  <tr @click="PreapreEditDomWatList(props.item)">
                    <td>{{ props.item.water_type ? props.item.water_type : '-' }}</td>
                    <td>{{ props.item.water_receipt ? props.item.water_receipt : '-' }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <!-- water level & storage -->
    <v-flex xs12>
      <v-card>
        <v-card-text class="pa-0">
          <v-flex xs12 class="pb-1 pt-2 pl-2">
            <span class="primary--text">Water Level and Storage</span>
          </v-flex>
          <v-flex xs12 class="pa-0">
            <v-data-table
            :headers="watStorage"
            :items="watList"
            :mobile-breakpoint="0"
            hide-default-footer>
            <template slot="item" slot-scope="props">
              <tr @click="PreapreEditWatStorage(props.item)">
                <td>{{ props.item.storage_nm ? props.item.storage_nm : '-' }}</td>
                <td>{{ props.item.water_cat }}</td>
                <td>{{ props.item.is_level_checked ? (props.item.water_level ? props.item.water_level : '-') : 'N/A' }}</td>
                <td class="px-2">{{ props.item.is_cons_checked ? (props.item.water_cons === null ? '-' : props.item.water_cons) : 'N/A' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</v-card-text>
</v-card>
<v-flex xs12 class="pa-2">
  <v-flex xs12 class="pt-2">
    <v-text-field
    v-model="lDailyUpdate.remark_water"
    label="Water Management Remark If Any"
    maxlength="150"
    hide-details
    @change="postObserv()"
    outlined
    ></v-text-field>
  </v-flex>
</v-flex>

<!-- Power Consumption -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div v-if="$vuetify.breakpoint.smAndUp" class="title primary--text">Power Consumption</div>
    <div v-else class="title primary--text">Power</div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="powerCons"
    :items="powerList.filter(rec => rec.meter_nm !== '')"
    :mobile-breakpoint="0"
    no-data-text="Power consumption is not applicable for this site"
    hide-default-footer
    >
    <template slot="item" slot-scope="props">
      <tr @click="prepareEditCons(props.item)">
        <td>{{ props.item.meter_nm ? props.item.meter_nm : '-' }}</td>
        <td>{{ props.item.units_cons ? props.item.units_cons : 0 }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Genset Power Consumption, Diesel Level & Stock -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div v-if="$vuetify.breakpoint.smAndUp" class="title primary--text">Genset Power Consumption, Diesel Level &amp; Stock</div>
    <div v-else class="title primary--text">Genset</div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="genPower"
    :items="gensetList"
    hide-default-footer
    :mobile-breakpoint="0"
    no-data-text="Genset is not applicable for this site"
    >
    <template slot="item" slot-scope="props">
      <tr @click="prepareEditGen(props.item)">
        <td>{{ props.item.genset_nm ? props.item.genset_nm : '-' }}</td>
        <td>{{ props.item.units_cons ? props.item.units_cons : '-' }}</td>
        <td>{{ props.item.level ? props.item.level : '-' }}</td>
        <td>{{ props.item.purchased ? props.item.purchased : '-' }}</td>
        <td>{{ props.item.stock ? props.item.stock : '-' }}</td>
        <td>{{ props.item.fuel_eff ? props.item.fuel_eff : '-' }}</td>
        <td>{{ props.item.kwh_kva ? props.item.kwh_kva : '-' }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>
<v-flex xs12 class="pa-2">
  <v-flex xs12 class="pt-2">
    <v-text-field
    v-model="lDailyUpdate.remark_power"
    label="Power Management Remark If Any"
    maxlength="150"
    hide-details
    @change="postObserv()"
    outlined
    ></v-text-field>
  </v-flex>
</v-flex>

<!-- Waste Management -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title primary--text">Waste Management</div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="wasteMana"
    :items="lWasteList"
    :mobile-breakpoint="0"
    hide-default-footer>
    <template slot="item" slot-scope="props">
      <tr @click="prepareEditWaste(props.item)">
        <td>{{ props.item.waste_type ? props.item.waste_type : '-' }}</td>
        <td>{{ props.item.kgs ? props.item.kgs : 0 }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Hygiene Management -->
<v-card class="ma-2" v-if="lSanCheck.length > 0">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title primary--text">Hygiene Management/Sanity Checks</div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-layout row wrap>
      <v-flex xs12 v-for="(cat, n) in lSanCheck" :key="n">
        <div class="pa-2 primary--text" v-if="cat.check_cat">{{ cat.check_cat }}</div>
        <v-flex xs12 class="pa-0">
          <v-data-table
          :mobile-breakpoint="0"
          hide-default-footer
          :items="sanCheckList.filter(rec => rec.check_cat === cat.check_cat)"
          >
          <template slot="item" slot-scope="props">
            <tr @click="prepareEditSanCheck(cat.check_cat)">
              <td class="pr-0" :style="$vuetify.breakpoint.smAndUp ? 'width: 300px;' : 'width: 150px;'">{{ props.item.check_desc ? props.item.check_desc : '-' }}</td>
              <td style="width: 50px;" class="pt-1 pr-0">
                <v-checkbox v-model="props.item.check_value" disabled hide-details></v-checkbox>
              </td>
              <td>Remarks: {{props.item.remark}}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-flex>
  </v-layout>
</v-card-text>
</v-card>
<v-flex xs12 class="pa-2" v-if="lSanCheck.length > 0">
  <v-flex xs12 class="pt-2">
    <v-text-field
    v-model="lDailyUpdate.remark_sanity_checks"
    label="Sanity Checks Remark If Any"
    maxlength="150"
    hide-details
    @change="postObserv()"
    outlined
    ></v-text-field>
  </v-flex>
</v-flex>

<!-- Custom Metrics -->
<v-card class="ma-2" v-if="lMet.length > 0">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title primary--text">Custom Metrics</div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-layout row wrap>
      <v-flex xs12 v-for="(metric, n) in lMet" :key="n">
        <div class="pa-2 primary--text" v-if="metric">{{ metric.metric_cat }}</div>
        <v-flex xs12 class="pa-0">
          <v-data-table
          :headers="metHead"
          :items="metricList.filter(rec => rec.metric_cat === metric.metric_cat)"
          :mobile-breakpoint="0"
          hide-default-footer>
          <template slot="item" slot-scope="props">
            <tr @click="prepareEditCusMet(props.item)">
              <td>{{ props.item.metric_nm ? props.item.metric_nm : '-' }}</td>
              <td>{{ props.item.metric_val ? props.item.metric_val : 0 }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-flex>
  </v-layout>
</v-card-text>
</v-card>
<v-flex xs12 class="pa-2" v-if="lMet.length > 0">
  <v-flex xs12 class="pt-2">
    <v-text-field
    v-model="lDailyUpdate.remark_custom_metrics"
    label="Custom Metrics Remark If Any"
    maxlength="150"
    hide-details
    @change="postObserv()"
    outlined
    ></v-text-field>
  </v-flex>
</v-flex>

<!-- Attendance summary -->
<v-dialog v-model="showSummary" persistent scrollable max-width="750px">
  <v-card>
    <v-card-title class="title grey lighten-4">
      <div>Attendance Summary</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showSummary = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp ? repHeadSm : repHead"
      :items="attReport"
      :mobile-breakpoint="0"
      hide-default-footer
      disable-pagination>
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.staff_role }}</td>
          <td class="pa-0">{{ props.item.tot_present }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_wo }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_holiday }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_ot }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_leave }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_absent }}</td>
          <td class="red--text pa-0">{{ props.item.tot_pend }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- Update Water Quality value -->
<v-dialog v-model="showWaterQual" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveWatQualChanges()">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4">
            {{ lWatQual.water_type + ' ' + lWatQual.param_name }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-text-field
              v-model="lWatQual.val"
              label="Value"
              :rules="[rules.required]"
              hide-details
              maxlength="5"
              type = "number"
              ></v-text-field>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showWaterQual = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<v-dialog v-model="showDomWat" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="dForm" @submit.prevent="saveDomWatChanges()">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4">
            {{ lDomWat.water_type }}
          </v-card-title>
          <v-card-text class="pt-3">
            <v-layout row wrap>
              <v-text-field
              v-model="lDomWat.water_receipt"
              label="Water Receipt (KL)"
              :rules="[rules.required]"
              hide-details
              type="number"
              ></v-text-field>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showDomWat = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Water Storage -->
<v-dialog v-model="showWatStorage" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="sForm" @submit.prevent="saveWatStorageChanges()">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4">
            {{ lWatStorage.storage_nm }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                v-model="lWatStorage.water_level"
                label="Water Level (%)"
                :rules="[rules.required]"
                :disabled="lWatStorage.is_level_checked === 0"
                :placeholder="lWatStorage.is_level_checked ? '' : 'N/A'"
                hide-details
                maxlength="11"
                type = "number"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12>
              <v-text-field
              v-model="lWatStorage.water_receipt"
              label="Water Receipt (KL)"
              :rules="[rules.required]"
              hide-details
              maxlength="11"
              type = "number"
              :disabled="lWatStorage.is_receipt_checked === 0"
              :placeholder="lWatStorage.is_receipt_checked ? '' : 'N/A'"
              ></v-text-field>
            </v-flex> -->
            <v-flex xs12 sm6>
              <v-text-field
              v-model="lWatStorage.water_cons"
              label="Water Consumption (KL)"
              :rules="[rules.required]"
              hide-details
              maxlength="11"
              type = "number"
              :disabled="lWatStorage.is_cons_checked === 0"
              :placeholder="lWatStorage.is_cons_checked ? '' : 'N/A'"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn @click.stop="showWatStorage = false">Cancel</v-btn>
          <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-container>
</v-dialog>

<!-- Update Power Consumption -->
<v-dialog v-model="showPowerCons" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="pForm" @submit.prevent="savePowerConsChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lPower.meter_nm }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lPower.units_cons"
                label="Units"
                :rules="[rules.required]"
                hide-details
                maxlength="11"
                type = "number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showPowerCons = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Power Genset -->
<v-dialog v-model="showPowerGen" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="gForm" @submit.prevent="savePowerGenChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lGenset.genset_nm }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 class="pa-0 pl-1">
                <span class="primary--text">Power</span>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-text-field
                v-model="lGenset.units_cons"
                label="Units Generated"
                :rules="[rules.required]"
                hide-details
                maxlength="11"
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-0 pt-3 pl-1">
                <span class="primary--text">Diesel</span>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-text-field
                v-model="lGenset.level"
                label="Level (%)"
                :rules="[rules.required]"
                hide-details
                maxlength="5"
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGenset.purchased"
                label="Purchased (ltr)"
                :rules="[rules.required]"
                hide-details
                maxlength="7"
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGenset.stock"
                label="Stock (ltr)"
                :rules="[rules.required]"
                hide-details
                maxlength="7"
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGenset.fuel_eff"
                label="Fuel eff. (units/ltr)"
                hide-details
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGenset.kwh_kva"
                label="KWH/KVA"
                hide-details
                disabled
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showPowerGen = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Waste Management -->
<v-dialog v-model="showWaste" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="wForm" @submit.prevent="saveWasteChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lWaste.waste_type + ' Waste' }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lWaste.kgs"
                label="Kgs"
                :rules="[rules.required]"
                hide-details
                maxlength="5"
                type = "number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showWaste = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Custom Metric -->
<v-dialog v-model="showCusMet" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="mForm" @submit.prevent="saveMetChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lMetric.metric_nm }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lMetric.metric_val"
                label="Value"
                :rules="[rules.required]"
                hide-details
                maxlength="5"
                type = "number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn @click.stop="showCusMet = false">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Show Uploaded Images -->
<v-dialog v-model="showUploadImage" scrollable max-width="900px">
  <v-container grid-list-md class="pa-0">
    <v-card>
      <v-card-title class="py-2 title grey lighten-4">
        <div>{{ 'Photos (' + handy.formatDate(lDate) + ')' }}</div>
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="showUploadImage = false"><v-icon>mdi-close</v-icon></v-btn>
        <v-flex xs12 class="py-2">
          <span v-for="(chip, index) in photoCatChips" :key="index">
            <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" :color="lDailyUpdateAttach.cat === chip.attach_cat_id ? 'info white--text' : ''" @click="loadCategoryImage(chip.attach_cat_id)">
              {{chip.attach_cat_name + (lDailyUpdateAttach.fileUrls ? (lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === chip.attach_cat_id).length ? (' (' + lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === chip.attach_cat_id).length + ')') : '') : '') }}</v-chip>
            </span>
            <v-chip :color="lDailyUpdateAttach.cat === 'All' ? 'info white--text' : ''" @click="loadCategoryImage('All')">All ({{lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.length}})</v-chip>
          </v-flex>
        </v-card-title>
        <v-card-text class="py-1">
          <v-container class="pa-0" fluid v-if="lDailyUpdateAttach.files && lDailyUpdateAttach.files.length > 0">
            <v-row>
              <v-col
              v-for="(file, index) in lDailyUpdateAttach.files" :key="index"
              class="d-flex child-flex pa-1"
              cols="4"
              >
              <v-card flat tile class="d-flex">
                <v-img
                :src="file.file_url"
                aspect-ratio="1"
                class="grey lighten-2"
                >
                <div style="position:absolute; top:5px; right:5px">
                  <v-menu
                  top right>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" small color="grey lighten-2">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <!-- list of menuitems -->
                  <v-list class="py-0">
                    <v-list-item @click.stop="deletePhoto(file)">
                      <v-list-item-title>Delete photo</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="PrepareNotes(file)">
                      <v-list-item-title>Notes</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="white--text text-center caption" style="background-color:rgba(125, 125, 125, 0.5);">{{handy.formatDateTime(file.attach_timestamp)}}<br />by {{file.user_name}}</div>
              <div style="position:absolute; bottom:0px; width:100%; background-color:rgba(0, 0, 255, 0.5);" class="text-center white--text caption" v-if="file.notes">
                {{ file.notes }}
              </div>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <span class="pa-2" v-else>No photos are taken yet.</span>
  </v-card-text>
  <v-card-actions class="grey lighten-4 caption">
    <v-flex xs12>
      <div class="text-center text-sm-right">
        <v-btn small dark fab color="accent" @click="prepareCamera"><v-icon>mdi-camera</v-icon></v-btn>
      </div>
    </v-flex>
  </v-card-actions>
</v-card>
</v-container>
</v-dialog>

<!-- Show camera to take photo -->
<v-dialog v-model="showCamera" max-width="310px">
  <v-card>
    <v-card-text>
      <video id="cam" style="width:280px; height:210px" autoplay></video>
      <v-flex xs12>
        <v-select
        v-model="lDailyUpdateAttach.attach_cat_id"
        :items="photoCatChips"
        item-text="attach_cat_name"
        item-value="attach_cat_id"
        label="Category"
        hide-details
        :rules="[rules.required]"
        solo
        ></v-select>
      </v-flex>
    </v-card-text>
    <div class="text-center pb-3 pt-0">
      <v-btn icon @click="capturePhoto"><v-icon x-large>mdi-camera-iris</v-icon></v-btn>
    </div>
    <div style="position:absolute; top:15px; right:10px">
      <v-btn small color="grey" icon @click.stop="closeCamDlg"><v-icon small>mdi-close</v-icon></v-btn>
    </div>
  </v-card>
</v-dialog>

<!-- Add/update notes -->
<v-dialog v-model="showNotes" persistent max-width="500px">
  <v-card>
    <v-card-title class="title grey lighten-4">
      Add or Update Notes
    </v-card-title>
    <v-card-text class="py-0">
      <v-flex xs12 class="pt-0">
        <v-textarea
        v-model="lNotes.notes"
        label="Notes"
        hide-details
        rows="2"
        ></v-textarea>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click.stop="showNotes = false">Cancel</v-btn>
      <v-btn type="submit" color="accent" @click="saveNotes(lNotes)">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-flex>
</v-container>

<!-- Checklist Lookup -->
<v-container class="pa-0" grid-list-md fluid full-height>
  <v-flex xs12 sm7 mx-auto v-if="lAction === 'lookup'">
    <v-form ref="lForm" @submit.prevent="applyLookup">
      <v-card>
        <v-card-title class="title grey lighten-4 pa-2">
          Checklist Lookup
        </v-card-title>
        <v-card-text class="pa-2">
          <v-flex xs12>
            <div class="caption primary--text" style="font-weight:bold;">Search By Date</div>
          </v-flex>
          <v-flex xs12 class="pt-2">
            <v-layout wrap>
              <v-flex xs6 class="pr-2">
                <v-dialog ref="dlgFromDate"
                persistent v-model="dlgFromDate"
                max-width="290px"
                :return-value.sync="lLookup.from_dt"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="Checklist From"
                  v-model="lLookup.from_dt"
                  append-icon="mdi-calendar-today"
                  readonly clearable
                  hide-details
                  required
                  v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lLookup.from_dt" scrollable
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn @click="dlgFromDate = false">Cancel</v-btn>
                <v-btn color="accent" @click="$refs.dlgFromDate.save(lLookup.from_dt)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="dlgToDate"
            persistent v-model="dlgToDate"
            max-width="290px"
            :return-value.sync="lLookup.to_dt"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="Checklist To"
              v-model="lLookup.to_dt"
              append-icon="mdi-calendar-today"
              readonly clearable
              hide-details
              required
              v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="lLookup.to_dt" scrollable
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn @click="dlgToDate = false">Cancel</v-btn>
            <v-btn color="accent" @click="$refs.dlgToDate.save(lLookup.to_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex xs12>
    <div class="caption primary--text pt-4" style="font-weight:bold;">Search By Community/User</div>
  </v-flex>
  <v-flex xs12 class="pt-2">
    <v-select
    v-model="lLookup.comm_id"
    :items="commList"
    item-text="comm_name"
    item-value="comm_id"
    label="Community"
    hide-details
    clearable
    ></v-select>
  </v-flex>
  <v-flex xs12 class="pt-1">
    <v-text-field
    v-model="lLookup.updated_by"
    label="Created/Updated By"
    hide-details
    maxlength="50"
    ></v-text-field>
  </v-flex>
  <v-flex xs12>
    <div class="caption primary--text pt-4" style="font-weight:bold;">Search By Status</div>
  </v-flex>
  <v-flex xs12 class="pt-2">
    <v-layout wrap>
      <v-flex xs6>
        <v-radio-group v-model="lLookup.is_sub_app" hide-details class="mt-0"
        label="Submitted for Approval" :mandatory="false">
        <v-radio label="Yes" value="1"></v-radio>
        <v-radio label="No" value="0"></v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex xs6>
      <v-radio-group v-model="lLookup.is_app" hide-details class="mt-0"
      label="Approved" :mandatory="false">
      <v-radio label="Yes" value="1"></v-radio>
      <v-radio label="No" value="0"></v-radio>
    </v-radio-group>
  </v-flex>
</v-layout>
</v-flex>
</v-card-text>
<v-card-actions>
  <v-btn @click.stop="cancelChanges">Close</v-btn>
  <v-spacer></v-spacer>
  <v-btn @click="clearLookup">Clear</v-btn>
  <v-btn type="submit" color="accent">Lookup</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-flex>
<v-flex xs12 class="pt-3" v-if="lmAction === 'lookup-result'">
  <v-flex xs12 class="pb-2">
    <v-text-field
    class="pa-0 mt-1"
    append-icon="mdi-account-search-outline"
    :placeholder="$vuetify.breakpoint.smAndUp?'Search community, date, etc...':'Search'"
    single-line
    hide-details
    v-model="search3"
    outlined
    clearable
    ></v-text-field>
  </v-flex>
  <v-card>
    <v-card-title class="title grey lighten-4 pa-2">
      Lookup Result ({{ lookupResult.length }})
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp?fmLookup:fmLookupSm"
      :items="lookupResult"
      :options.sync="pagination"
      class="elevation-1"
      :search="search3"
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="loadDailyUpdateBasedOnComm(props.item, 'Lookup')">
          <td v-if="$vuetify.breakpoint.smAndUp">{{ handy.formatDate(props.item.c_date) }}</td>
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.updated_by_name }}</td>
          <td>{{ props.item.updated_on ? handy.formatDisplayDateTime(props.item.updated_on) : '' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.is_sub_app ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.is_app ? 'Yes' : 'No' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.app_on ? handy.formatDisplayDateTime(props.item.app_on) : '' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.app_by_name }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>
</v-container>

<!-- 3. show Timeline for particular task_id -->
<v-dialog v-model="showTimeline" scrollable max-width="620px">
  <v-card>
    <v-card-title class="py-1 title grey lighten-4">
      <div>Timeline</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showTimeline = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-3 pl-0">
      <v-timeline dense class="pt-0">
        <v-timeline-item :class="n === lTimeLine.length-1 ? 'pb-0' : ''"
        v-for="(timeline, n) in lTimeLine"
        :key="n" color="red lighten-2"
        small
        icon="mdi-star" fill-dot
        :id="'timeline_' + n"
        >
        <v-card>
          <v-card-text class="black--text">
            {{ timeline.updated_by_name }} has
            <span v-if="timeline.category === 'Attach the photos' || timeline.category === 'Submitted for Approval' || timeline.category === 'Approved'"></span>
            <span v-else>updated</span>
            {{ timeline.category }}
            <span class="grey--text pl-1">on {{ handy.formatDate(timeline.action_dt) + ' ' + handy.getTime12Hrs(timeline.action_dt) }}</span>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </v-card-text>
</v-card>
</v-dialog>

<!-- 4. -edit or update sanity checks value -->
<v-dialog v-model="showSanCheck" persistent scrollable max-width="650px">
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text" v-if="sanCheck.length > 0">{{sanCheck[0].check_cat}} <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showSanCheck = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-flex xs12 v-for="(sanity, n) in sanCheck" :key="n">
        <v-layout row wrap>
          <v-flex xs4>
            <v-text-field
            v-model="sanity.check_desc"
            disabled
            hide-details
            class="pb-1"
            ></v-text-field>
          </v-flex>
          <v-flex xs1 class="pl-3">
            <v-checkbox v-model="sanity.check_value" :disabled="sanity.check_desc === 'Garbage Disposal' ? true : false" hide-details></v-checkbox>
          </v-flex>
          <v-flex xs7>
            <v-text-field
            v-model="sanity.remark"
            placeholder="Add remark if any"
            :disabled="sanity.check_desc === 'Garbage Disposal' ? true : false"
            hide-details
            class="pb-1"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="accent" @click="saveSanCheck(sanCheck, null)">save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<!-- loading -->
<div v-if="load" style="position:absolute; top:50%; left:40%">
  <v-progress-circular indeterminate color="info"></v-progress-circular>
</div>

</v-container>
</div>
</template>

<script>
import VDownloadAs from '@/components/VDownloadAs.vue'
import handy from '@/utils/handy'
import config from '@/config/app-cfg'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      beingSaved: false,
      handy: handy,
      config: config,
      rules: handy.rules,
      fab: false,
      lAction: '',
      search1: '',
      search2: '',
      search3: '',
      load: false,
      tab: 'tab-0',
      tabItems: ['pend. app', 'pend. sub'],
      fmUpdate: [
        { text: 'Date', value: 'c_date' },
        { text: 'Community', value: 'comm_name' },
        { text: 'Created/Updated By', value: 'updated_by_staff_name' },
        { text: 'Updated On', value: 'updated_on' }
      ],
      fmUpdateSm: [
        { text: 'Community', value: 'comm_name' },
        { text: 'Created/Updated By', value: 'updated_by_staff_name' },
        { text: 'Updated On', value: 'updated_on' }
      ],
      fmSub: [
        { text: 'Date', value: 'c_date' },
        { text: 'Community', value: 'comm_name' },
        { text: 'Created/Updated By', value: 'updated_by' },
        { text: 'Updated On', value: 'updated_on' },
        { text: 'Status', value: 'status' }
      ],
      lFmUpdate: { 0: [], 1: []},
      lDailyUpdate: [{
        ia_app: 0,
        is_sub_app: 0,
        major_observ: '',
        vendor_id: config.VENDOR_ID,
        updated_by: config.SV_USER_ID
      }],
      lSummary: [{
        tot_present: 0,
        tot_wo: 0,
        tot_holiday: 0,
        tot_ot: 0,
        tot_leave: 0,
        tot_absent: 0,
        tot_pend: 0,
        tot_staff: 0,
        attAve: 0
      }],
      attendance: [
        { text: 'Present', value: 'tot_present' },
        { text: 'Weekoff', value: 'tot_wo' },
        { text: 'Holiday', value: 'tot_holiday' },
        { text: 'Standby/OT', value: 'tot_ot' },
        { text: 'Leave', value: 'tot_leave' },
        { text: 'Absent', value: 'tot_absent' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-2' },
        { text: 'Total', value: 'tot_staff', class: 'black--text pr-2' }
      ],
      attendanceSm: [
        { text: 'Present', value: 'tot_present' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' },
        { text: 'Total', value: 'tot_staff', class: 'black--text pr-0 pl-2' }
      ],
      watQual: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Parameter', value: 'param_name' },
        { text: 'Recommended', value: 'std_val_min' },
        { text: 'Value', value: 'val' }
      ],
      watQualSm: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Parameter', value: 'param_name' },
        { text: 'Value', value: 'val' }
      ],
      watList: [],
      domWatList: [],
      watTypeDt: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Value', value: 'water_receipt' },
        { text: 'Date', value: 'c_date' }
      ],
      watType: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Receipt (KL)', value: 'water_receipt' }
      ],
      lDomWat: [],
      showDomWat: false,
      lMet: {},
      wasteMana: [
        { text: 'Wastage Type', value: 'waste_type' },
        { text: 'Kgs', value: 'kgs' }
      ],
      lWasteList: [],
      gensetList: [],
      genPower: [
        { text: 'Genset', value: 'genset_nm' },
        { text: 'Units Generated', value: 'units_cons' },
        { text: 'Current Diesel Level (%)', value: 'level' },
        { text: 'Purchased (ltr)', value: 'purchased' },
        { text: 'Stock (ltr)', value: 'stock' },
        { text: 'Fuel Eff. (units/ltr)', value: 'fuel_eff' },
        { text: 'KWH/KVA', value: 'kwh_kva' }
      ],
      powerCons: [
        { text: 'Meter', value: 'meter_nm' },
        { text: 'Units', value: 'units_cons' }
      ],
      powerList: [],
      watStorage: [
        { text: 'Name', value: 'storage_nm' },
        { text: 'Category', value: 'water_cat' },
        { text: 'Level (%)', value: 'water_level' },
        // { text: 'Receipt (KL)', value: 'water_receipt' },
        { text: 'Consumption (KL)', value: 'water_cons', class: 'pa-2' }
      ],
      dailyQualList: [],
      metHead: [
        { text: 'Metric Name', value: 'metric_nm', width: '300px' },
        { text: 'Value', value: 'metric_val', width: '100px' }
      ],
      metricList: [],
      lFmDailyUpdate: [],
      showSummary: false,
      repHeadSm: [
        { text: 'Role [Headcount]', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Weekoff', value: 'tot_wo' },
        { text: 'Holiday', value: 'tot_holiday' },
        { text: 'Standby/OT', value: 'tot_ot' },
        { text: 'Leave', value: 'tot_leave' },
        { text: 'Absent', value: 'tot_absent' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      repHead: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      attReport: [],
      showUploadImage: false,
      showWaste: false,
      showPowerGen: false,
      showPowerCons: false,
      showWatStorage: false,
      showWaterQual: false,
      showCusMet: false,
      lWatQual: [],
      lWatStorage: {},
      lPower: [],
      lGenset: [],
      lWaste: [],
      lMetric: [],
      lDailyUpdateAttach: [],
      photoCatChips: [],
      showCamera: false,
      showNotes: false,
      lNotes: {},
      lDate: null,
      lCommId: null,
      lCommName: '',
      wasteType: ['Organic', 'Dry', 'Rejected'],
      totalStats: {},
      pagination: {},
      lSanCheck: {},
      sanCheckList: [],
      sanCheck: [],
      showSanCheck: false,
      reportChip: ['Last Month', 'Last Week', 'Yesterday', 'Today', 'This Week', 'This Month', 'Period'],
      enableChip: '',
      fromDate: null,
      toDate: null,
      aDay: false,
      dlgFromDate: false,
      dlgToDate: false,
      periodFrom: null,
      periodTo: null,
      // Checklist Lookup
      dlgFromDate: false,
      lLookup: [],
      commList: [],
      lmAction: '',
      lookupResult: [],
      fmLookup: [
        { text: 'Date', value: 'c_date' },
        { text: 'Community Name', value: 'comm_name' },
        { text: 'Created/Updated By', value: 'emp_name' },
        { text: 'Updated On', value: 'updated_on' },
        { text: 'Submitted For Approval?', value: 'is_sub_app' },
        { text: 'Approved?', value: 'is_app' },
        { text: 'Approved On', value: 'app_on' },
        { text: 'Approved By', value: 'app_by_name' }
      ],
      fmLookupSm: [
        { text: 'Community Name', value: 'comm_name' },
        { text: 'Created/Updated By', value: 'emp_name' },
        { text: 'Updated On', value: 'updated_on' }
      ],
      comingFrom: '',
      downloadPendApp: [],
      downloadPendSub: [],
      wasteInserted: false,
      showTimeline: false,
      lTimeLine: {}
    }
  },
  created () {
    for (var i = 0; i < this.tabItems.length; i++) {
      this.totalStats[i] = 0
    }
    this.loadPendApprovalList()
  },
  mounted () {
    this.lAction = 'view'
    var curDate = new Date()
    this.periodFrom = this.periodTo = handy.formatDBDate(curDate)
    this.loadPendSubBasedOnPeriod('Yesterday')
  },
  computed: {
    chosenPeriod: function () {
      return ' [' + ((this.enableChip === 'Today' || this.enableChip === 'Yesterday') ? handy.formatDate(this.fromDate) : handy.formatDate(this.fromDate) + ' to ' + handy.formatDate(this.toDate)) + ']'
    }
  },
  methods: {
    refreshData () {
      this.lAction = 'view'
      if (this.tab === 'tab-0') {
        this.loadPendApprovalList()
      } else {
        this.loadPendSubmissionList()
      }
      this.lmAction = ''
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
    },
    loadPendApprovalList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getFmUpdateList/', qry)
      .then(response => {
        this.lFmUpdate[0] = response.data
        this.downloadPendApp = []
        response.data.forEach(rec => {
          this.downloadPendApp.push({
            c_date: rec.c_date,
            updated_on: rec.updated_on,
            comm_name: rec.comm_name,
            updated_by_staff_name: rec.updated_by_staff_name
          })
        })
        this.totalStats[0] = this.lFmUpdate[0].length
      })
      .catch(err => {
        this.msg(err)
        this.lFmUpdate[0] = []
        this.downloadPendApp = []
      })
    },
    loadPendSubmissionList () {
      this.lFmUpdate[1] = []
      this.loading()
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          from_dt: this.fromDate,
          to_dt: this.toDate
        }
      }
      this.axios.get(config.API_URL + '/getFMUpdatePendSubmission/', qry)
      .then(response => {
        this.lFmUpdate[1] = response.data.filter(rec => rec.is_sub_app !== 1)
        this.downloadPendSub = []
        this.lFmUpdate[1].forEach(rec => {
          this.downloadPendSub.push({
            c_date: rec.c_date ? handy.formatDBDate(rec.c_date) : '',
            updated_on: rec.updated_on ? handy.formatDisplayDateTime(rec.updated_on) : '',
            comm_name: rec.comm_name,
            updated_by: rec.updated_by,
            status: rec.staff_name ? 'Draft' : 'NA'
          })
        })
        this.totalStats[1] = this.lFmUpdate[1].length
        this.load = false
      })
      .catch(err => {
        this.msg(err)
        this.load = false
        this.downloadPendSub = []
      })
    },
    goBackToView () {
      if (this.comingFrom === 'Lookup') {
        this.lmAction = 'lookup-result'
        this.lAction = 'lookup'
      } else {
        this.loadPendApprovalList()
        this.loadPendSubmissionList()
        this.lAction = 'view'
      }
    },
    loadPendSubBasedOnPeriod (curChip) {
      // find the period based on selection
      this.enableChip = curChip
      this.fromDate = this.toDate = null
      var curDate = new Date()
      if (curChip === 'Today') {
        this.fromDate = this.toDate = curDate
      } else if (curChip === 'Yesterday') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 1))
        this.toDate = this.fromDate
      } else if (curChip === 'This Week') {
        this.toDate = new Date()
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - (curDate.getDay() - 1)))
      } else if (curChip === 'Last Week') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 7 - (curDate.getDay() - 1)))
        this.toDate = new Date(curDate.setDate(curDate.getDate() + 6))
      } else if (curChip === 'This Month') {
        this.fromDate = new Date(curDate.getFullYear(), curDate.getMonth(), 1)
        this.toDate = curDate
      } else if (curChip === 'Last Month') {
        curDate.setDate(1)
        this.fromDate = new Date(curDate.setMonth(curDate.getMonth() - 1))
        this.toDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0)
      } else {
        if (this.periodTo < this.periodFrom) {
          this.msg('From date has to be less than or equal to To date', 0)
          return
        }
        this.fromDate = new Date(this.periodFrom)
        this.toDate = new Date(this.periodTo)
      }
      // convert the period into required format
      this.fromDate = handy.formatDBDate(this.fromDate)
      this.toDate = handy.formatDBDate(this.toDate)
      // refresh the stat or list
      this.loadPendSubmissionList()
    },
    loadDailyUpdate (curUpdate) {
      var qry = {
        params: {
          comm_id: curUpdate.comm_id,
          c_date: curUpdate && curUpdate.c_date ? handy.formatDBDate(curUpdate.c_date) : null,
          from_dt: curUpdate && curUpdate.c_date ? handy.formatDBDate(curUpdate.c_date) : null,
          to_dt: curUpdate && curUpdate.c_date ? handy.formatDBDate(curUpdate.c_date) : null
        }
      }
      this.lDailyUpdate = []
      this.axios.get(config.SMARTILITY_API_URL + '/getDailyUpdateByDate/', qry)
      .then(response => {
        if (response.data.length) {
          this.lDailyUpdate = response.data[0]
        }
        if (this.lDailyUpdate.is_app_by_sv_user || this.lDailyUpdate.is_updated_by_sv_user) {
          var qry1 = {
            params: {
              user_id: this.lDailyUpdate.updated_by
            }
          }
          this.axios.get(config.SMARTILITY_API_URL + '/getCustNameOfSVUser/', qry1)
          .then(response => {
            this.lDailyUpdate.cust_name = handy.startWithUpper(response.data[0].user_name)
          })
        }
        if (curUpdate) {
          this.loadTimeLine(handy.formatDBDate(curUpdate.c_date))
        }
      })
    },
    loadDailyUpdateBasedOnComm (curUpdate, comingFrom = 'Frontend') {
      this.comingFrom = comingFrom
      this.lFmDailyUpdate = Object.assign({}, curUpdate)
      this.loadDailyUpdate(curUpdate)
      this.lDate = handy.formatDBDate(curUpdate.c_date)
      this.lCommId = curUpdate.comm_id
      this.lDailyUpdate.comm_id = curUpdate.comm_id
      this.lCommName = curUpdate.comm_name
      var qry = {
        params: {
          comm_id: curUpdate.comm_id,
          c_date: handy.formatDBDate(curUpdate.c_date),
          from_dt: handy.formatDBDate(curUpdate.c_date),
          to_dt: handy.formatDBDate(curUpdate.c_date),
          is_billable: 1
        }
      }

      this.dailyQualList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getDailyWaterQualityByCommId/', qry)
      .then(response => {
        this.dailyQualList = response.data
      })

      this.lSummary = [{
        tot_present: 0,
        tot_wo: 0,
        tot_holiday: 0,
        tot_ot: 0,
        tot_leave: 0,
        tot_absent: 0,
        tot_pend: 0,
        tot_staff: 0,
        attAve: 0
      }]
      this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceByCommId/', qry)
      .then(response => {
        this.lSummary[0].tot_staff = response.data.length
        this.lSummary[0].tot_present = response.data.filter(att => att.attendance === 'Present' || att.attendance === 'Present + OT').length
        this.lSummary[0].tot_absent = response.data.filter(att => att.attendance === 'Absent').length
        this.lSummary[0].tot_leave = response.data.filter(att => att.attendance && att.attendance.includes('Leave')).length
        this.lSummary[0].tot_wo = response.data.filter(att => att.attendance === 'Weekly Off' || att.attendance === 'Weekly Off + OT').length
        this.lSummary[0].tot_ot = response.data.filter(att => att.attendance && (att.attendance.includes('OT') || att.sby_vendor_emp_id || att.sby_temp_staff_name)).length
        this.lSummary[0].tot_pend = response.data.filter(att => !att.attendance).length
        // adjust half days
        this.lSummary[0].tot_holiday = response.data.filter(att => att.attendance === 'Holiday').length
        this.lSummary[0].tot_hd = response.data.filter(att => att.attendance === 'Half Day').length
        this.lSummary[0].tot_present = response.data.filter(att => att.attendance === 'Present' || att.attendance === 'Present + OT').length + (this.lSummary[0].tot_hd / 2)
        this.lSummary[0].tot_absent = this.lSummary[0].tot_absent + (this.lSummary[0].tot_hd / 2)
        this.lSummary[0].attAve = Math.round((this.lSummary[0].tot_present + this.lSummary[0].tot_ot + this.lSummary[0].tot_wo + this.lSummary[0].tot_holiday) / (this.lSummary[0].tot_staff) * 100)
      })

      this.domWatList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterSourcesByCommIdAndcDate/', qry)
      .then(response => {
        this.domWatList = response.data
      })

      this.watList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterStorageByCommIdAndcDate/', qry)
      .then(response => {
        this.watList = response.data
      })

      this.powerList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerConsByCommIdAndcDate/', qry)
      .then(response => {
        this.powerList = response.data
      })

      this.gensetList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerGensetByCommIdAndcDate/', qry)
      .then(response => {
        this.gensetList = response.data
      })

      this.lWasteList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getWasteByCommIdAndcDate/', qry)
      .then(response => {
        var wasteList = response.data.map(rec => rec.waste_type)
        for (var i = 0; i < response.data.length; i++) {
          this.lWasteList.push({
            c_date: handy.formatDBDate(response.data[i].c_date),
            waste_type: response.data[i].waste_type,
            kgs: response.data[i].kgs
          })
        }
        // fill-in gaps
        this.wasteType.forEach(type => {
          var cIdx = wasteList.indexOf(type)
          if (cIdx < 0) {
            this.lWasteList.push({
              waste_type: type,
              kgs: '',
              c_date: this.lDate
            })
          }
        })
      })

      this.axios.get(config.SMARTILITY_API_URL + '/getMetricCatByCommId/', qry)
      .then(response => {
        this.lMet = response.data.filter(rec => rec.metric_cat !== '')
        var qry1 = {
          params: {
            comm_id: curUpdate.comm_id,
            from_dt: handy.formatDBDate(curUpdate.c_date),
            to_dt: handy.formatDBDate(curUpdate.c_date),
            metric_cat: this.lMet.map(rec => rec.metric_cat)
          }
        }
        this.axios.get(config.SMARTILITY_API_URL + '/getMetricByCommId/', qry1)
        .then(response => {
          this.metricList = response.data
        })
      })

      this.axios.get(config.SMARTILITY_API_URL + '/getPhotoCatByCommId/', qry)
      .then(response => {
        this.photoCatChips = response.data
        this.lDailyUpdateAttach.cat = this.photoCatChips[0].attach_cat_id
        this.lDailyUpdateAttach.attach_cat_id = this.lDailyUpdateAttach.cat
      })

      this.axios.get(config.SMARTILITY_API_URL + '/getSanCheckCatByCommId/', qry)
      .then(response => {
        this.lSanCheck = response.data
        this.axios.get(config.SMARTILITY_API_URL + '/getSanCheckByCommIdAndcDate/', qry)
        .then(response => {
          this.sanCheckList = response.data
          if (this.wasteInserted) {
            this.sanCheckList.forEach(rec => {
              if (rec.check_desc.includes('Garbage Disposal')) {
                var idx = this.sanCheckList.findIndex(rec => rec.check_desc === 'Garbage Disposal')
                this.sanCheckList[idx].remark = ''
                var string = ''
                this.lWasteList.forEach(waste => {
                  if (waste.kgs) {
                    string += waste.waste_type + ': ' + waste.kgs + 'kg '
                    this.sanCheckList[idx].remark = string
                  }
                })
                if (this.sanCheckList[idx].remark) {
                  this.sanCheckList[idx].c_date = this.lDate
                  this.sanCheckList[idx].comm_id = this.lDailyUpdate.comm_id
                  this.sanCheckList[idx].updated_by = config.SV_USER_ID
                  this.sanCheckList[idx].comm_name = this.lCommName
                  this.sanCheckList[idx].is_updated_by_sv_user = true
                  this.sanCheckList[idx].check_value = true
                  this.saveSanCheck(this.sanCheckList[idx], string)
                } else {
                  this.sanCheckList[idx].check_value = false
                }
              }
            })
            this.wasteInserted = false
          }
        })
      })

      this.loadFacDailyUpdateAttachment(handy.formatDBDate(curUpdate.c_date))
      this.loadTimeLine(handy.formatDBDate(curUpdate.c_date))
      this.lAction = 'update'
      this.lmAction = ''
    },
    approveUpdate () {
      if (!confirm('Sure, you want to Approve it ?')) {
        return
      }
      this.lDailyUpdate.c_date = handy.formatDBDate(this.lFmDailyUpdate.c_date)
      this.lDailyUpdate.app_by = config.SV_USER_ID
      this.lDailyUpdate.is_app_by_sv_user = true
      this.lDailyUpdate.comm_name = this.lCommName
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/approve-dailyupdate', this.lDailyUpdate)
      .then(response => {
        this.msg('Approved successfully', 1)
        this.loadDailyUpdateBasedOnComm(this.lDailyUpdate)
        // this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    postObserv () {
      var remark = {}
      remark.remark_attendance = this.lDailyUpdate.remark_attendance
      remark.remark_water = this.lDailyUpdate.remark_water
      remark.remark_power = this.lDailyUpdate.remark_power
      remark.remark_sanity_checks = this.lDailyUpdate.remark_sanity_checks
      remark.remark_custom_metrics = this.lDailyUpdate.remark_custom_metrics
      this.lDailyUpdate.c_date = remark.c_date = this.lDate
      remark.comm_id = this.lDailyUpdate.comm_id
      remark.updated_by = config.SV_USER_ID
      remark.is_updated_by_sv_user = true
      remark.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      remark.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/major-observ', remark)
      .then(response => {
        this.msg('Saved successfully', 1)
        this.loadDailyUpdate(this.lDailyUpdate)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCamera () {
      this.showCamera = true
      this.lDailyUpdateAttach.attach_cat_name = !this.lDailyUpdateAttach.cat || this.lDailyUpdateAttach.cat === 'All' ? 'Briefing' : this.lDailyUpdateAttach.cat
      if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        alert('Sorry, your browser does not support this feature\nTry using google chrome')
        return
      }
      // start camera and play
      navigator.mediaDevices.getUserMedia({video: {facingMode: 'environment'}})
      .then(stream => { // success
        document.querySelector('video').srcObject = stream
        this.localMediaStream = stream
      })
      .catch(error => {
        console.error('Webcam access is rejected: ' + error)
      })
    },
    closeCamDlg () {
      this.showCamera = false
      // stop the camera
      if (this.localMediaStream) {
        // stop the camera
        var tracks = this.localMediaStream.getTracks()
        tracks.forEach(function (track) {
          track.stop()
        })
        this.localMediaStream.srcObject = null
      }
    },
    loadFacDailyUpdateAttachment (curDate) {
      var qry = {
        params: {
          from_dt: curDate,
          to_dt: curDate,
          comm_id: this.lCommId
        }
      }
      this.lDailyUpdateAttach.fileUrls = []
      this.lDailyUpdateAttach.files = []
      this.axios.get(config.SMARTILITY_API_URL + '/getAttachmentByCDate/', qry)
      .then(response => {
        this.lDailyUpdateAttach.fileUrls = response.data
        this.lDailyUpdateAttach.cat = this.lDailyUpdateAttach.cat || 'All'
        if (this.lDailyUpdateAttach.cat === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === this.lDailyUpdateAttach.cat)
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
        this.lDailyUpdateAttach.fileUrls = []
      })
    },
    PrepareNotes (curFile) {
      this.lNotes = Object.assign({}, curFile)
      this.showNotes = true
    },
    saveNotes (curNotes) {
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdateAttach/notes', curNotes)
      .then(response => {
        this.loadFacDailyUpdateAttachment(this.lDate)
        this.beingSaved = false
        this.showNotes = false
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadCategoryImage (curcategory) {
      if (curcategory) {
        this.lDailyUpdateAttach.files = []
        this.lDailyUpdateAttach.cat = curcategory
        if (curcategory === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === curcategory)
        }
        this.$forceUpdate()
      }
    },
    capturePhoto () {
      const canvas = document.createElement('canvas')
      const video = document.querySelector('#cam')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0)
      // upload to db
      let newPhoto = {
        c_date: this.lDate,
        comm_id: this.lDailyUpdate.comm_id,
        user_id: config.SV_USER_ID,
        user_name: config.USER_NAME,
        file_name: (handy.formatDBDateTime(new Date()) + '.png').replace(' ', '-').replace(/:/g, '-'),
        file_url: canvas.toDataURL('image/png'),
        attach_cat_id: this.lDailyUpdateAttach.attach_cat_id,
        is_updated_by_sv_user: false,
        is_app: this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0,
        is_sub_app: this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      }
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdateAttach/create', newPhoto)
      .then(response => {
        // update the front end
        setTimeout(() => {
          this.loadFacDailyUpdateAttachment(this.lDate)
          this.loadTimeLine(this.lDate)
        }, 500)
      })
      .catch(err => {
        this.msg(err.response.data)
      })
      // stop the camera
      this.closeCamDlg()
    },
    deletePhoto (curFile) {
      if (!confirm('Sure, you want to delete the photo?')) {
        return
      }
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdateAttach/delete', curFile)
      .then(response => {
        // update the front end
        var idx = this.lDailyUpdateAttach.fileUrls.findIndex(rec => (rec.c_date === curFile.c_date) && (rec.comm_id === curFile.comm_id) && (rec.file_url === curFile.file_url))
        this.lDailyUpdateAttach.fileUrls.splice(idx, 1)
        if (this.lDailyUpdateAttach.cat === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === this.lDailyUpdateAttach.cat)
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    prevDay () {
      var date = new Date(this.lDate)
      date.setDate(date.getDate() - 1)
      this.lDate = handy.formatDBDate(date)
      this.lDailyUpdate.c_date = this.lDate
      this.lDailyUpdate.comm_id = this.lCommId
      this.lDailyUpdate.comm_name = this.lCommName
      this.loadDailyUpdateBasedOnComm(this.lDailyUpdate)
    },
    nextDay () {
      var date = new Date(this.lDate)
      date.setDate(date.getDate() + 1)
      this.lDate = handy.formatDBDate(date)
      this.lDailyUpdate.c_date = this.lDate
      this.lDailyUpdate.comm_id = this.lCommId
      this.lDailyUpdate.comm_name = this.lCommName
      this.loadDailyUpdateBasedOnComm(this.lDailyUpdate)
    },
    showAttendanceSummary (curdate) {
      var qry = {
        params: {
          comm_id: this.lDailyUpdate.comm_id,
          from_dt: curdate,
          to_dt: curdate,
          group_by: 'role',
          is_billable: 1
        }
      }
      this.showSummary = true
      this.attReport = []
      this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceRep/', qry)
      .then(response => {
        this.attReport = response.data
        // calculate few fields
        this.attReport.forEach(rec => {
          rec.staff_role = rec.staff_role + ' [' + rec.role_count + ']'
          rec.tot_present = rec.tot_present + (rec.tot_hd / 2)
          rec.tot_absent = rec.tot_absent + (rec.tot_hd / 2)
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEditWaterQual (curWatQual) {
      this.lWatQual = Object.assign({}, curWatQual)
      this.showWaterQual = true
    },
    saveWatQualChanges () {
      if (!this.$refs.lForm.validate()) {
        return
      }
      this.lWatQual.c_date = this.lDate
      this.lWatQual.comm_id = this.lDailyUpdate.comm_id
      this.lWatQual.updated_by = config.SV_USER_ID
      this.lWatQual.comm_name = this.lCommName
      this.lWatQual.is_updated_by_sv_user = true
      this.lWatQual.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lWatQual.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/water-qual', this.lWatQual)
      .then(response => {
        var idx = this.dailyQualList.findIndex(rec => rec.param_id === this.lWatQual.param_id)
        Object.assign(this.dailyQualList[idx], this.lWatQual)
        this.beingSaved = false
        this.showWaterQual = false
        this.loadDailyUpdate(this.lWatQual)
      })
      .catch(err => {
        this.msg(err, true)
        this.beingSaved = false
        this.showWaterQual = false
      })
    },
    PreapreEditDomWatList (curWatType) {
      this.lDomWat = Object.assign({}, curWatType)
      this.showDomWat = true
    },
    saveDomWatChanges () {
      if (!this.$refs.dForm.validate()) {
        return
      }
      this.beingSaved = true
      this.lDomWat.c_date = this.lDate
      this.lDomWat.comm_id = this.lDailyUpdate.comm_id
      this.lDomWat.updated_by = config.SV_USER_ID
      this.lDomWat.comm_name = this.lCommName
      this.lDomWat.is_updated_by_sv_user = true
      this.lDomWat.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lDomWat.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/water-sources', this.lDomWat)
      .then(response => {
        var idx = this.domWatList.findIndex(rec => rec.water_type_id === this.lDomWat.water_type_id)
        Object.assign(this.domWatList[idx], this.lDomWat)
        this.beingSaved = false
        this.showDomWat = false
        this.loadDailyUpdate(this.lDomWat)
      })
      .catch(err => {
        this.beingSaved = false
        this.msg(err, 0)
      })
    },
    PreapreEditWatStorage (curWarSt) {
      this.lWatStorage = Object.assign({}, curWarSt)
      this.showWatStorage = true
    },
    saveWatStorageChanges () {
      if (!this.$refs.sForm.validate()) {
        return
      }
      if (this.lWatStorage.water_level < 0 || this.lWatStorage.water_level > 100) {
        this.msg('Please add the values of level between 0-100 only', 0)
      } else {
        this.beingSaved = true
        this.lWatStorage.c_date = this.lDate
        this.lWatStorage.comm_id = this.lDailyUpdate.comm_id
        this.lWatStorage.updated_by = config.SV_USER_ID
        this.lWatStorage.comm_name = this.lCommName
        this.lWatStorage.is_updated_by_sv_user = true
        this.lWatStorage.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
        this.lWatStorage.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
        this.lWatStorage.water_level = this.lWatStorage.water_level ? this.lWatStorage.water_level : null
        this.lWatStorage.water_receipt = this.lWatStorage.water_receipt ? this.lWatStorage.water_receipt : null
        this.lWatStorage.water_cons = this.lWatStorage.water_cons ? this.lWatStorage.water_cons : null
        this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/water-storage', this.lWatStorage)
        .then(response => {
          var idx = this.watList.findIndex(rec => rec.storage_id === this.lWatStorage.storage_id)
          Object.assign(this.watList[idx], this.lWatStorage)
          this.beingSaved = false
          this.showWatStorage = false
          this.loadDailyUpdate(this.lWatStorage)
        })
        .catch(err => {
          this.beingSaved = false
          this.msg(err, 0)
        })
      }
    },
    prepareEditCons (curCons) {
      this.lPower = Object.assign({}, curCons)
      this.showPowerCons = true
    },
    savePowerConsChanges () {
      if (!this.$refs.pForm.validate()) {
        return
      }
      this.beingSaved = true
      this.lPower.c_date = this.lDate
      this.lPower.comm_id = this.lDailyUpdate.comm_id
      this.lPower.updated_by = config.SV_USER_ID
      this.lPower.comm_name = this.lCommName
      this.lPower.is_updated_by_sv_user = true
      this.lPower.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lPower.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/power-cons', this.lPower)
      .then(response => {
        var idx = this.powerList.findIndex(rec => rec.meter_id === this.lPower.meter_id)
        Object.assign(this.powerList[idx], this.lPower)
        this.beingSaved = false
        this.showPowerCons = false
        this.loadDailyUpdate(this.lPower)
        this.$forceUpdate()
      })
      .catch(err => {
        this.beingSaved = false
        this.msg(err, 0)
      })
    },
    prepareEditGen (curGen) {
      this.lGenset = Object.assign({}, curGen)
      this.showPowerGen = true
    },
    savePowerGenChanges () {
      if (!this.$refs.gForm.validate()) {
        return
      }
      if (this.lGenset.level < 0 || this.lGenset.level > 100) {
        this.msg('Please add the values of level between 0-100 only', 0)
      } else {
        this.beingSaved = true
        this.lGenset.c_date = this.lDate
        this.lGenset.comm_id = this.lDailyUpdate.comm_id
        this.lGenset.updated_by = config.SV_USER_ID
        this.lGenset.comm_name = this.lCommName
        this.lGenset.is_updated_by_sv_user = true
        this.lGenset.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
        this.lGenset.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
        this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/power-genset', this.lGenset)
        .then(response => {
          var idx = this.gensetList.findIndex(rec => rec.genset_id === this.lGenset.genset_id)
          Object.assign(this.gensetList[idx], this.lGenset)
          this.beingSaved = false
          this.showPowerGen = false
          this.loadDailyUpdate(this.lGenset)
        })
        .catch(err => {
          this.beingSaved = false
          this.msg(err, 0)
        })
      }
    },
    prepareEditWaste (curWaste) {
      this.lWaste = Object.assign({}, curWaste)
      this.showWaste = true
    },
    saveWasteChanges () {
      if (!this.$refs.wForm.validate()) {
        return
      }
      this.beingSaved = true
      this.lWaste.c_date = this.lDate
      this.lWaste.comm_id = this.lDailyUpdate.comm_id
      this.lWaste.updated_by = config.SV_USER_ID
      this.lWaste.comm_name = this.lCommName
      this.lWaste.is_updated_by_sv_user = true
      this.lWaste.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lWaste.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/waste-management', this.lWaste)
      .then(response => {
        this.beingSaved = false
        this.showWaste = false
        this.wasteInserted = true
        this.loadDailyUpdateBasedOnComm(this.lWaste)
      })
      .catch(err => {
        this.showWaste = false
        this.beingSaved = false
        this.msg(err, 0)
      })
    },
    prepareEditCusMet (curCusMet) {
      this.lMetric = Object.assign({}, curCusMet)
      this.showCusMet = true
    },
    saveMetChanges () {
      this.lMetric.c_date = this.lDate
      this.lMetric.comm_id = this.lDailyUpdate.comm_id
      this.lMetric.updated_by = config.SV_USER_ID
      this.lMetric.comm_name = this.lCommName
      this.lMetric.is_updated_by_sv_user = true
      this.lMetric.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lMetric.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/cus-metric', this.lMetric)
      .then(response => {
        var idx = this.metricList.findIndex(rec => rec.metric_id === this.lMetric.metric_id)
        Object.assign(this.metricList[idx], this.lMetric)
        this.loadDailyUpdate(this.lMetric)
        this.beingSaved = false
        this.showCusMet = false
      })
      .catch(err => {
        this.beingSaved = false
        this.showCusMet = false
        this.msg(err, 0)
      })
    },
    submitApproval () {
      this.lDailyUpdate.c_date = this.lDate
      this.lDailyUpdate.updated_by = config.SV_USER_ID
      this.lDailyUpdate.comm_name = this.lCommName
      this.lDailyUpdate.is_updated_by_sv_user = true
      this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/submit-for-approval', this.lDailyUpdate)
      .then(response => {
        this.msg('Successfully submitted for approval', 1)
        this.loadDailyUpdateBasedOnComm(this.lDailyUpdate)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareLookup () {
      this.lAction = 'lookup'
      this.loadCommunity()
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.commList = []
      })
    },
    clearLookup () {
      this.lLookup = {
        from_dt: null,
        to_dt: null,
        comm_id: null,
        updated_by: '',
        is_sup_app: null,
        is_app: null
      }
      this.search3 = ''
    },
    cancelChanges () {
      this.clearLookup()
      this.lAction = 'view'
      this.lmAction = ''
    },
    applyLookup () {
      if (this.lLookup.from_dt > this.lLookup.to_dt) {
        this.msg('to date should be greater than from date')
      } else {
        if (!this.lLookup.from_dt && this.lLookup.to_dt) {
          this.lLookup.from_dt = this.lLookup.to_dt
        } else if (this.lLookup.from_dt && !this.lLookup.to_dt) {
          this.lLookup.to_dt = this.lLookup.from_dt
        }
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID,
            comm_id: this.lLookup.comm_id,
            from_dt: this.lLookup.from_dt,
            to_dt: this.lLookup.to_dt,
            is_sub_app: this.lLookup.is_sub_app || null,
            is_app: this.lLookup.is_app || null,
            updated_by: this.lLookup.updated_by
          }
        }
        this.lookupResult = []
        this.axios.get(config.API_URL + '/getChecklistLookup/', qry)
        .then(response => {
          this.lookupResult = response.data
          this.lmAction = 'lookup-result'
        })
        .catch(err => {
          this.msg(err)
          this.lookupResult = []
        })
      }
    },
    prepareEditSanCheck (curcat) {
      this.sanCheck = this.sanCheckList.filter(rec => rec.check_cat === curcat)
      this.showSanCheck = true
    },
    saveSanCheck (curSanCheck, curString) {
      if (curString) {
        curSanCheck.c_date = this.lDate
        curSanCheck.comm_id = this.lCommId
        curSanCheck.updated_by = config.SV_USER_ID
        curSanCheck.comm_name = this.lCommName
        curSanCheck.is_updated_by_sv_user = true
        curSanCheck.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
        curSanCheck.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
        this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/sancheck', curSanCheck)
        .then(response => {
          if (!curString) {
            this.msg('Saved successfully', 1)
          }
          this.loadDailyUpdate(curSanCheck)
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        for (var i = 0; i < curSanCheck.length; i++) {
          if (curSanCheck[i] !== 'Garbage Disposal') {
            curSanCheck[i].c_date = this.lDate
            curSanCheck[i].comm_id = this.lCommId
            curSanCheck[i].updated_by = config.SV_USER_ID
            curSanCheck[i].comm_name = this.lCommName
            curSanCheck[i].is_updated_by_sv_user = true
            curSanCheck[i].is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
            curSanCheck[i].is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
            this.axios.post(config.SMARTILITY_API_URL + '/facilityDailyUpdate/sancheck', curSanCheck[i])
            .then(response => {
              this.showSanCheck = false
              this.msg('Saved successfully', 1)
              this.loadDailyUpdate(curSanCheck[i])
              this.$forceUpdate()
            })
            .catch(err => {
              this.msg(err, 0)
            })
          }
        }
      }
    },
    loadTimeLine (curDate) {
      var qry = {
        params: {
          c_date: curDate,
          comm_id: this.lDailyUpdate.comm_id
        }
      }
      this.lTimeLine = {}
      this.axios.get(config.SMARTILITY_API_URL + '/getTimelineDetailsofDailyReport/', qry)
      .then(response => {
        this.lTimeLine = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.lTimeLine = {}
        this.showTimeline = false
      })
    }
  }
}
</script>
